<header class="background-header classic-background"></header>
<section class="main-side-nav" id="mainSideNav"
    [ngClass]="{hideOnMobile:sideNavBarVisibilityService.hideOnMobile==true, 'main-side-nave-theme': themeService.theme != 'default'}"> && themeService.theme != 'boosst'
    <section class="container admin-dashboard-parent delegate-referral-container">
        <section class="template-section-title">
            <div class="breadcrumb-container">
                <span>Admin <i class="fa fas fa-chevron-right"></i></span>
                <app-breadcrumb [pageName]="'Delegate Referral'" [isTopLevel]="true"></app-breadcrumb>
            </div>
            <div class="title-container">
                <h1>Delegate Referral</h1>
            </div>
        </section>
        <!-- Search -->
        <section class="all-users-line-presentation">
            <div class="search-section">
                <div class="accounts-number">
                    <span *ngIf="delegates">{{delegates.length}} Delegates</span>
                </div>
                <div class="buttons-managment">
                    <input type="button" class="btn btn-primary export-btn" value="Export" (click)="exportToExcel()">
                    <!-- <input type="text" class="dashboard-input" placeholder="Last Name" [(ngModel)]="searchData">
                    <input type="button" class="btn btn-primary search-btn" value="Search"
                        (click)="searchByLastName(searchData)"> -->
                </div>
            </div>
        </section>

        <!-- Table of data sought -->
        <section class="all-users-data" *ngIf="isSearching">
            <div class="table-responsive admin-dashboard-table">
                <table class="table table-hover table-borderless">
                    <thead>
                        <tr>
                            <!-- <th scope="col" (click)="sortColumns('firstName')"> -->
                            <th scope="col">
                                Delegate Name
                                <!-- <i [ngClass]="{'sorted-icon': firstNameSorted==true}" class="fa fas fa-arrow-up"></i> -->
                            </th>
                            <!-- <th scope="col" (click)="sortColumns('email')"> -->
                            <th scope="col">
                                Email
                                <!-- <i [ngClass]="{'sorted-icon': emailSorted==true}" class="fa fas fa-arrow-up"></i> -->
                            </th>
                            <th scope="col">Delegate Type</th>
                            <th scope="col">Plan Holder</th>
                            <th scope="col">Sponsor</th>
                            <th scope="col">Creation Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let dataUser of filteredDelegates">
                            <!-- Display filtered data -->
                            <td><span *ngIf="dataUser.delegateName">{{dataUser.delegateName}}</span></td>
                            <td>{{dataUser.delegateEmail}}</td>
                            <td>{{dataUser.delegateRelation}}</td>
                            <td>{{dataUser.planHolderName}}</td>
                            <td>{{dataUser.company}}</td>
                            <td>{{dataUser.delegateCreationDate | date:'dd/MM/yyyy'}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>

        <!-- Table of data not sought-->
        <section class="all-users-data" *ngIf="isSearching == false">
            <div class="table-responsive admin-dashboard-table">
                <table class="table table-hover table-borderless">
                    <thead>
                        <tr>
                            <!-- <th scope="col" (click)="sortColumns('firstName')"> -->
                                <th scope="col">
                                    Delegate Name
                                    <!-- <i [ngClass]="{'sorted-icon': firstNameSorted==true}" class="fa fas fa-arrow-up"></i> -->
                                </th>
                                <!-- <th scope="col" (click)="sortColumns('email')"> -->
                                <th scope="col">
                                    Email
                                    <!-- <i [ngClass]="{'sorted-icon': emailSorted==true}" class="fa fas fa-arrow-up"></i> -->
                                </th>
                            <th scope="col">Delegate Type</th>
                            <th scope="col">Plan Holder</th>
                            <th scope="col">Sponsor</th>
                            <th scope="col">Creation Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let dataUser of delegates">
                            <td><span *ngIf="dataUser.delegateName">{{dataUser.delegateName}}</span></td>
                            <td>{{dataUser.delegateEmail}}</td>
                            <td>{{dataUser.delegateRelation}}</td>
                            <td>{{dataUser.planHolderName}}</td>
                            <td>{{dataUser.company}}</td>
                            <td>{{dataUser.delegateCreationDate | date:'dd/MM/yyyy'}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>


    </section>
</section>